import http from "./HttpService";

class ApiService {
  loginBiometric(data) {
    return http.post("/biometric/login", data);
  }

  registerBiometric(data) {
    return http.post("/biometric/register", data);
  }

  generateToken(data, apiKey) {
    return http.post("/external/token", data, {
      headers: {
        ApiKey: apiKey,
      },
    });
  }

  getBiometricStatus(token) {
    return http.get(`/external/token/biometric-active-liveness?token=${token}`);
  }

  checkBiometricActiveLiveness(token) {
    return http.get(`/external/token/biometric-active-liveness?token=${token}`);
  }
}

export default new ApiService();
